import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=3b47a187&scoped=true"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"
import style0 from "./Licenses.vue?vue&type=style&index=0&id=3b47a187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b47a187",
  null
  
)

export default component.exports